import styled from "styled-components";

export const FormSteps = styled.div`
  height: 100%;
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 20px;
  .steps {
    align-items: center;
    padding: 10px 20px;
    display: flex;
    border-bottom: 1px solid #CFD3DD;
    &__title {
      font-size: 20px;
      font-family: "Nunito Sans Bold";
      color: #1F1F52;
      margin-right: 10px;
    }
  }
  .step-container {
    height: calc(100% - 55px);
  }
`